import React from "react";
import { useTranslation } from "i18n";
import cx from "classnames";
import ProfileCard from "pages/Profile/components/common/ProfileCard";
import { useGetTraining } from "pages/Profile/hooks/useGetTraining";
import { TRAINING_FULL_PATH } from "shared/constants";
import { usePublicView } from "pages/Profile/hooks/usePublicView";
import NoDataMessage from "pages/Profile/components/common/NoDataMessage";
import ExpandableSanitizedHtml from "../common/ExpandableSanitizedHtml";

interface Props {
  isEdit?: boolean;
}

const TrainingSection = ({ isEdit }: Props) => {
  const { t } = useTranslation();
  const { isPublicView } = usePublicView();
  const { isLoading, notes = "" } = useGetTraining();

  const isTrainingSectionHidden = !notes && isPublicView;
  const isNoData = !notes && !isPublicView;

  if (isTrainingSectionHidden) {
    return null;
  }

  return (
    <ProfileCard
      className={cx("dark:text-white/90", { "grid min-h-[141px]": isNoData })}
      isEdit={isEdit}
      isLoading={isLoading}
      editToPath={TRAINING_FULL_PATH}
    >
      {isNoData ? (
        <NoDataMessage
          category={t("performer:profile.training.title")}
          content={t("performer:profile.training.noData.content")}
        />
      ) : (
        <>
          <h2 className="text-m uppercase dark:text-white">
            {t("performer:profile.training.title")}
          </h2>
          <ExpandableSanitizedHtml
            html={notes}
            limit={900}
            lineClamp={10}
            contentClassName="text-s"
          />
        </>
      )}
    </ProfileCard>
  );
};

export default TrainingSection;
